import { LandingHeader } from "../components/landing/LandingHeader";
import { LandingMarquee } from "../components/landing/LandingMarquee";
import { LandingHero } from "../components/landing/LandingHero";
import { LandingSchedule } from "../components/landing/LandingSchedule";
import { LandingMap } from "../components/landing/LandingMap";
import { LandingWhy } from "../components/landing/LandingWhy";
import { LandingPricing } from "../components/landing/LandingPricing";
import { LandingCTA } from "../components/landing/LandingCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FFF4E6]">
      <LandingHeader />
      <LandingMarquee />
      <LandingHero />
      <LandingSchedule />
      <LandingMap />
      <LandingWhy />
      <LandingPricing />
      <LandingCTA />
    </div>
  );
}
